<template>
<div
  :class="['meal-widget', { 'with-dishes': dishCount && !dishToAdd, 'select-opts': selectOpts, 'adding-dish': dishToAdd !== null }]"
  ref="mealWidget"
  @click="handleWidgetClick"
>
  <transition-group name="bounce" v-if="dishCount && !selectOpts && !dishToAdd">
    <div
      v-for="(meal, i) in meals"
      :key="meal.dishId"
      class="meal-widget-item"
      :class="{ last: isLastVisibleDish(i) }"
      :style="`backgroundImage: url(${meal.imageUrl || meal.imageURL}); left: ${i * 1.6}rem; display: ${i + 1 > visibleDishCount ? 'none' : 'flex'}`"
    >
      <span class="remaining-dish-count" v-if="isLastVisibleDish(i)">+ {{ hiddenDishCount }}</span>
    </div>
  </transition-group>

  <h3 class="text-add" v-if="!dishCount && !selectOpts && !dishToAdd">
    {{ $t('calender.lblTapAddRecipe') }}
  </h3>
  <h3 class="text-add" v-if="dishToAdd !== null && !selectOpts"> {{ $t('lblAdd') }} {{ dishToAdd.name }} to {{ this.mealTimeSlot }} </h3>

  <span @click.stop="selectOpts = !selectOpts">
    <svg class="add-icon plus" :class="{ hidden: dishToAdd !== null }" svg-inline="" v-if="!selectOpts" focusable="false" role="presentation" width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M16 14h6a1 1 0 010 2h-6v6a1 1 0 01-2 0v-6H8a1 1 0 010-2h6V8a1 1 0 012 0v6z" id="a"/></defs><g fill="none" fill-rule="evenodd" opacity=".4"><circle fill="#F7C11C" cx="20" cy="20" r="20"/><g transform="translate(5 5)"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><use fill="#000" fill-rule="nonzero" xlink:href="#a"/><g mask="url(#b)" fill="#FFF"><path d="M0 0h30v30H0z"/></g></g></g></svg>
    <svg class="add-icon plus rotated" :class="{ hidden: dishToAdd !== null }" svg-inline="" v-if="selectOpts" focusable="false" role="presentation" width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M16 14h6a1 1 0 010 2h-6v6a1 1 0 01-2 0v-6H8a1 1 0 010-2h6V8a1 1 0 012 0v6z" id="a"/></defs><g fill="none" fill-rule="evenodd" opacity=".4"><circle fill="#F7C11C" cx="20" cy="20" r="20"/><g transform="translate(5 5)"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><use fill="#000" fill-rule="nonzero" xlink:href="#a"/><g mask="url(#b)" fill="#FFF"><path d="M0 0h30v30H0z"/></g></g></g></svg>
  </span>

  <span class="select-opts-btns" v-if="selectOpts && !dishToAdd">
    <span @click.stop="showRecipes" v-if="dishToAdd === null">
      <BaseButton type="button" class="btn btn-block">{{ $t('calender.buttonCookSomething') }}</BaseButton>
    </span>
    <!-- <span class="leftover-btn" @click.stop="handleShowLeftoverOpts" v-if="dishToAdd === null">
      <BaseButton type="button" class="btn btn-block btn-ghost btn-with-icon">
        <svg class="leftover-icon" svg-inline="" focusable="false" role="presentation" width="266" height="236" viewBox="0 0 266 236" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path d="M262.444 145.488a12.919 12.919 0 001.412-2.276l.018-.038a12.206 12.206 0 00.404-.944 9.79 9.79 0 00.114-.312 9.68 9.68 0 00.182-.564c.346-1.156.534-2.382.534-3.65 0-7.016-5.688-12.702-12.702-12.702h-44.82a13.068 13.068 0 0012.06-8.036c.032-.078.064-.154.094-.232L250 40.074h2.406c3.926 0 7.436-1.782 9.766-4.58.028-.034.056-.066.082-.1.168-.206.328-.416.482-.63l.106-.15a10.365 10.365 0 00.302-.456c.26-.41.496-.836.71-1.276l.018-.038a13.16 13.16 0 00.538-1.314c.022-.064.044-.126.064-.19a12.725 12.725 0 00.634-3.972c0-7.016-5.688-12.702-12.702-12.702H13.594C6.578 14.666.892 20.354.892 27.368a12.736 12.736 0 001.236 5.476l.018.038a12.584 12.584 0 001.012 1.732 12.471 12.471 0 00.588.78l.082.1a12.677 12.677 0 009.766 4.58H16l30.26 76.66a13.265 13.265 0 00.994 1.998 13.068 13.068 0 0011.16 6.27h-44.82c-7.016 0-12.702 5.688-12.702 12.702 0 1.268.188 2.494.534 3.65l.068.224c.036.114.076.228.114.34l.114.312a11.994 11.994 0 00.422.982 12.11 12.11 0 00.686 1.238 12.602 12.602 0 001.18 1.59c.122.14.246.276.372.41.006.006.012.014.02.02a12.384 12.384 0 001.734 1.514c.118.086.236.17.356.25.084.056.17.114.256.168a12.58 12.58 0 001.902 1.002c.096.04.19.08.286.118a12.513 12.513 0 002.724.734c.63.096 1.276.146 1.934.146H16l30.26 76.66a13.022 13.022 0 003.296 4.808l.178.162a13.634 13.634 0 001.732 1.3l.206.126a14.902 14.902 0 00.842.466c.11.056.22.108.332.162a13 13 0 005.568 1.244h149.174a13.051 13.051 0 005.9-1.406l.214-.11c.212-.112.422-.232.628-.356.068-.042.138-.084.204-.126.096-.06.19-.122.282-.184.106-.072.212-.144.318-.218a13.47 13.47 0 001.132-.898l.178-.162a13.055 13.055 0 003.296-4.808l30.26-76.66h2.406a12.834 12.834 0 002.248-.198 12.805 12.805 0 002.696-.8 12.953 12.953 0 002.9-1.71 13.153 13.153 0 001.74-1.656c.156-.176.308-.36.454-.55z" fill="#9A9A9A"/><path d="M207.586 221.334H58.414a13.067 13.067 0 01-12.154-8.268l-33.238-84.202C9.638 120.29 15.956 111 25.176 111h215.648c9.218 0 15.538 9.288 12.154 17.864l-33.238 84.202a13.07 13.07 0 01-12.154 8.268z" fill="#E6E7E8"/><path d="M187.856 221.334H78.144c-3.946 0-7.49-3.278-8.938-8.268L44.76 128.864C42.27 120.29 46.918 111 53.698 111H212.3c6.78 0 11.428 9.288 8.938 17.864l-24.444 84.202c-1.448 4.988-4.992 8.268-8.938 8.268z" fill="#FFF"/><path d="M252.406 136.406H13.594c-7.016 0-12.702-5.688-12.702-12.704C.892 116.686 6.58 111 13.594 111h238.814c7.016 0 12.702 5.688 12.702 12.702 0 7.016-5.688 12.704-12.704 12.704z" fill="#EF5A9D"/><path d="M13.594 136.406h238.814c7.016 0 12.702-5.688 12.702-12.704H.89c0 7.016 5.688 12.704 12.704 12.704z" fill="#E43D91"/><path d="M173.15 155.642h-80.3c-10.75 0-19.462-8.714-19.462-19.462v-12.476h119.226v12.476c-.002 10.748-8.716 19.462-19.464 19.462z" fill="#F06EA9"/><path d="M180.908 141.486h-92.55a3.81 3.81 0 110-7.62h92.55a3.812 3.812 0 013.812 3.81 3.813 3.813 0 01-3.812 3.81z" fill="#EF5A9D"/><path d="M220.77 203.912H45.23c-.902 0-1.792-.068-2.66-.196l3.69 9.35a13.067 13.067 0 0012.154 8.268h149.174a13.067 13.067 0 0012.154-8.268l3.69-9.35c-.87.13-1.76.196-2.662.196z" fill="#D1D3D4"/><path d="M207.586 111H58.414a13.067 13.067 0 01-12.154-8.268L13.022 18.53C9.638 9.956 15.956.666 25.176.666h215.648c9.218 0 15.538 9.288 12.154 17.864l-33.238 84.202A13.067 13.067 0 01207.586 111z" fill="#E6E7E8"/><path d="M187.856 111H78.144c-3.946 0-7.49-3.278-8.938-8.268L44.76 18.53C42.27 9.956 46.918.666 53.698.666H212.3c6.78 0 11.428 9.288 8.938 17.864l-24.444 84.202c-1.448 4.99-4.992 8.268-8.938 8.268z" fill="#FFF"/><path d="M252.406 26.072H13.594C6.578 26.072.892 20.384.892 13.37.892 6.354 6.58.666 13.594.666h238.814c7.016 0 12.702 5.688 12.702 12.704 0 7.016-5.688 12.702-12.704 12.702z" fill="#EF5A9D"/><path d="M13.594 26.072h238.814c7.016 0 12.702-5.688 12.702-12.702H.89c0 7.014 5.688 12.702 12.704 12.702z" fill="#E43D91"/><path d="M173.15 45.308h-80.3c-10.75 0-19.462-8.714-19.462-19.462V13.37h119.226v12.476c-.002 10.748-8.716 19.462-19.464 19.462z" fill="#F06EA9"/><path d="M180.908 31.154h-92.55a3.81 3.81 0 110-7.62h92.55a3.812 3.812 0 013.812 3.81 3.813 3.813 0 01-3.812 3.81z" fill="#EF5A9D"/><path d="M220.77 93.578H45.23c-.902 0-1.792-.068-2.66-.196l3.69 9.35A13.067 13.067 0 0058.414 111h149.174a13.067 13.067 0 0012.154-8.268l3.69-9.35c-.87.13-1.76.196-2.662.196z" fill="#D1D3D4"/></g></svg>
        <span>{{ $t('calender.buttonLeftOvers') }}</span>
      </BaseButton>
    </span> -->
  </span>

  <span v-if="dishToAdd !== null && !selectOpts">
    <svg class="add-icon open-circle" :class="{ hidden: dishToAdd === null }" svg-inline="" focusable="false" role="presentation" width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg"><circle cx="28" cy="31" r="12" fill="none" transform="translate(-15 -18)" stroke="#F7C11C" stroke-width="2"/></svg>
  </span>

  <!-- <div class="tag-leftovers" v-if="dishCount && hasLeftovers && !selectOpts && !dishToAdd"> {{ leftoversTag }}</div> -->

  <div class="dish-deets" v-if="dishCount && !selectOpts && !dishToAdd">
    <span class="carbs">{{ $t('lblCarbs') }} {{ formattedMacro(mealTime, 'carbs') ? formattedMacro(mealTime, 'carbs').unit : 'n/a' }}</span>
    <span class="protein">{{ $t('lblProtien') }} {{ formattedMacro(mealTime, 'protein') ? formattedMacro(mealTime, 'protein').unit : 'n/a' }}</span>
    <span class="fat">{{ $t('lblFat') }} {{ formattedMacro(mealTime, 'fat') ? formattedMacro(mealTime, 'fat').unit : 'n/a' }}</span>
  </div>

  <span class="empty-mealtime-notice" v-if="!dishCount && !selectOpts && !dishToAdd">
    {{ $t('calender.lblScheduleSomething') }}
  </span>
</div>
</template>

<script>
import store from '@state/store';
import environment from '@src/environment';
import {
  kitchenDrawerComputed,
  kitchenDrawerMethods,
  planComputed,
  planMethods,
  dishesMethods,
  mainMethods,
  primaryNavMethods,
  groceryListMethods,
} from '@state/helpers';
import { macrosMixin } from 'macrosMixin';
import { planMixin } from 'planMixin';

export default {
  mixins: [planMixin, macrosMixin],
  components: {},
  props: {
    day: {
      type: Object,
      required: true,
    },
    isEmbed: {
      type: Boolean,
    },
    mealTime: {
      type: Object,
      required: true,
    },
    mealTimeSlot: {
      type: String,
      required: true,
    },
    plan: {
      type: Object,
      required: true,
    },
    onTabletUp: {
      type: Boolean,
    },
  },
  data() {
    return {
      visibleDishCount: 5,
      selectOpts: false,
    };
  },
  computed: {
    ...kitchenDrawerComputed,
    ...planComputed,
    dishCount() {
      return this.mealTime.meals.concat(this.mealTime.recipes).concat(this.mealTime.leftovers).length;
    },
    mealTimeSlotTitle() {
      return `${this.day.header.split(' ')[0] + ' ' + this.mealTimeSlot}`;
    },
    meals() {
      return this.mealTime.meals.concat(this.mealTime.recipes);
    },
    hasLeftovers() {
      if (this.mealTime.leftovers) {
        return this.mealTime.leftovers.length ? true : false;
      }
    },
    hasLeftoverOptions() {
      if (this.mealTime.leftoverOptions) {
        return this.mealTime.leftoverOptions.length ? true : false;
      }
    },
    leftoversTag() {
      let tagContent = `${this.mealTime.leftovers.length} `;

      if (this.mealTime.leftovers.length) {
        return (tagContent += this.mealTime.leftovers.length > 1 ? this.$t('lblLeftovers') : this.$t('lblLeftover'));
      }
    },
    hiddenDishCount() {
      return this.dishCount - this.visibleDishCount;
    },
  },
  mounted() {},
  methods: {
    ...dishesMethods,
    ...kitchenDrawerMethods,
    ...mainMethods,
    ...planMethods,
    ...primaryNavMethods,
    ...groceryListMethods,
    selectDaySlot() {
      this.setSelectedDaySlot({
        day: this.day,
        mealTime: this.getMealTime(this.mealTimeSlot),
        name: this.mealTimeSlot,
      });
    },
    isLastVisibleDish(i) {
      return i + 1 == this.visibleDishCount && this.dishCount > this.visibleDishCount;
    },
    setDailSummaryValues() {
      const dateString = this.day.dateString.substring(0, this.day.dateString.indexOf('T'));

      this.setDailySummary({
        day: this.day,
        mealTime: this.getMealTime(this.mealTimeSlot),
        planDays: this.plan.planDays,
        name: this.mealTimeSlot,
        selectedDate: dateString,
      });
    },
    async showPlanSummary() {
      await this.calcWidgetTarget();
      await this.toggleDrawer({ desiredState: 'open' });
      this.setDailSummaryValues();
      this.setActiveNav({
        title: this.$t('lblDailySummary'),
        component: 'PlanSummary',
        context: 'drawerModal',
      });
    },
    async showRecipes() {
      await this.calcWidgetTarget();
      if (this.dishToAdd === null) {
        await this.toggleDrawer({ desiredState: 'open' });
        this.selectOpts = false;
        this.selectDaySlot();
        this.setActiveNav({
          title: this.mealTimeSlotTitle,
          component: 'Recipes',
          context: 'drawerModal',
        });
      }
    },
    async showLeftoverOpts() {
      await this.calcWidgetTarget();
      await this.toggleDrawer({ desiredState: 'open' });
      this.selectOpts = false;
      this.selectDaySlot();
      this.setDailSummaryValues();
      this.setActiveNav({
        title: 'Select Leftover Dish',
        component: 'PlanLeftoverOptions',
        data: {
          mealTime: this.mealTimeSlot,
        },
      });
    },
    async add() {
      if (this.dishToAdd !== null) {
        const payload = {
          ...this.dishToAdd,
          date: this.day.dateString,
          planDayId: this.day.id,
          planMealTime: this.getMealTime(this.mealTimeSlot),
        };
        await this.addDish(payload);
        this.getCurrentPlanGrid().finally(() => {
          if (this.onTabletUp === undefined || this.onTabletUp) {
            return this.getGroceryList();
          }
        });
        this.setDishToAdd(null);
      }
    },
    handleShowLeftoverOpts() {
      this.hasLeftoverOptions ? this.showLeftoverOpts() : this.$bvModal.show('no-leftovers-modal');
    },
    handleWidgetClick() {
      if (this.dishToAdd !== null) {
        this.add();
      } else {
        this.dishCount ? this.showPlanSummary() : (this.selectOpts = true);
      }
    },
    calcWidgetTarget() {
      const offsets = this.$refs.mealWidget.getBoundingClientRect();
      const buffer = 100;
      this.setDrawerTransitionOrigin(`${offsets.x + buffer}px ${offsets.y + buffer}px`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.meal-widget {
  align-items: flex-start;
  background-color: $color-meal-widget-bg;
  border: 1px solid $color-meal-widget-border;
  border-radius: $base-border-radius;
  display: flex;
  flex-direction: row;
  height: 180px;
  justify-content: space-around;
  padding: 1.5rem 0;
  position: relative;
  width: 180px;

  &:not(:last-child) {
    margin-bottom: 0.5rem;
  }

  .dish-deets {
    span {
      display: block;
      font-size: 1.2rem;
      font-weight: 100;
      margin-bottom: 0.5rem;

      &::before {
        border-radius: 50%;
        content: '';
        display: inline-block;
        height: 5px;
        margin-right: 0.5rem;
        position: relative;
        top: -1px;
        width: 5px;
      }

      &.carbs::before {
        background-color: $color-carbs;
      }

      &.protein::before {
        background-color: $color-protein;
      }

      &.fat::before {
        background-color: $color-fat;
      }
    }
  }

  .add-icon {
    align-self: center;
    height: 4rem;
    opacity: 1;
    position: absolute;
    right: 0.8rem;
    top: 2rem;
    transition: opacity $size-meal-widget-add-duration;
    width: 4rem;

    &.hidden {
      opacity: 0;
    }

    &.open-circle circle {
      stroke: $color-action;
    }

    &.plus g {
      circle {
        fill: $color-action;
      }
    }

    &.rotated {
      transform: rotate(45deg);
    }
  }

  .icon-add {
    color: $color-meal-widget-icon-add;
  }

  .text-add {
    color: $color-action;
    flex: 0.6;
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 1.4;
  }

  .empty-mealtime-notice {
    align-self: flex-end;
    color: $color-meal-widget-empty-mealtime-notice;
    font-size: 1.1rem;
    left: 1.5rem;
    position: absolute;
  }

  &.with-dishes {
    align-items: flex-start;
    flex-direction: column;
    justify-content: space-between;
    padding: 1.5rem;
    position: relative;

    .empty-mealtime-notice {
      display: none;
    }

    .meal-widget-item {
      align-items: flex-end;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      border: 2px solid $color-meal-widget-item-border;
      border-radius: $border-radius-circle;
      box-shadow: $color-meal-widget-item-shadow;
      color: $color-meal-widget-item-text;
      font-weight: bold;
      height: 5rem;
      margin-left: 1.2rem;
      padding: 1rem 0.5rem;
      position: absolute;
      width: 5rem;

      .meal-name {
        font-size: 1.2rem;
        text-shadow: $color-meal-widget-item-name-shadow;
        z-index: 1;
      }

      &.last {
        align-items: center;
        background: $color-meal-widget-item-last-bg;
        background-image: none !important;
        border-width: 3px;
        display: flex;
        justify-content: center;

        .remaining-dish-count {
          color: $color-meal-widget-item-last-dish-count;
          font-size: 1.2rem;
        }
      }
    }

    .tag-leftovers {
      background-color: $color-meal-widget-tag-leftovers-bg;
      border: $color-meal-widget-tag-leftovers-border;
      border-radius: $base-border-radius-btn + 1;
      color: $color-meal-widget-tag-leftovers-text;
      font-size: 1.4rem;
      padding: 0.5rem 1.4rem;
      position: relative;
      top: 1.4rem;
      width: 100%;
    }

    .text-add {
      display: none;
    }
  }

  &.select-opts {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding-left: 1rem;
    padding-right: 1rem;

    .select-opts-btns {
      width: 100%;

      span {
        .btn {
          padding: 0.5rem 1.4rem;
          text-align: center;
        }

        &:first-of-type .btn {
          margin-bottom: 1rem;
        }

        &.leftover-btn button {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;

          .leftover-icon {
            height: 2rem;
            margin-right: 1rem;
            width: 2rem;
          }
        }
      }
    }
  }

  &.adding-dish {
    .text-add {
      color: lighten($color-lightGrey, 25);
      transition: color 0.3s linear;
    }

    .add-icon.open-circle circle {
      stroke: lighten($color-lightGrey, 25);
      transition: stroke 0.3s linear;
    }

    &:hover {
      cursor: pointer;

      .text-add {
        color: $color-action;
      }

      .add-icon.open-circle circle {
        stroke: $color-action;
      }
    }
  }
}

.bounce-enter-active {
  animation: bounce-in 0.3s;
  transition: opacity 0.3s;
}

.bounce-enter {
  opacity: 0;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
}
</style>

<style lang="scss" scoped>







</style>
